const hasError = state => state.error !== null
const error = state => state.error
const isLoading = state => state.isLoading
const hasCompanyBankAccountSettings = state => state.companyBankAccountsSettings.length > 0
const companyBankAccountSettings = state => state.companyBankAccountsSettings
const getPrivatBankFormState = state => state.privatBankState
const getAvalBankFormState = state => state.avalBankState
const isSendFormCompanyBankAccountSettings = state => state.isSendFormCompanyBankAccountSettings
const getCompanyPrivatBankAccountSettings = state => state.companyBankAccountsSettings.filter((item) => item.bank.alias === 'privat')
const getCompanyAvalBankAccountSettings = state => state.companyBankAccountsSettings.filter((item) => item.bank.alias === 'aval')

export default {
  hasError,
  error,
  isLoading,
  hasCompanyBankAccountSettings,
  companyBankAccountSettings,
  getPrivatBankFormState,
  isSendFormCompanyBankAccountSettings,
  getCompanyPrivatBankAccountSettings,
  getCompanyAvalBankAccountSettings,
  getAvalBankFormState,
}
